import { useState } from 'react';

import classNames from 'classnames';

import { EmailModal } from './EmailModal';

interface SubscribeAllButtonProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  email?: string;
  translations?: Record<string, string>;
}

export const SubscribeAllButton: React.FC<SubscribeAllButtonProps> = ({
  isLoading = false,
  isDisabled = false,
  email,
  translations,
}) => {
  const [emailCaptureOpen, setEmailCaptureOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="submit"
        onClick={(e) => {
          if (isDisabled) return;
          if (!email) {
            e.preventDefault();
            setEmailCaptureOpen(true);
          }
        }}
        disabled={isLoading || isDisabled}
        className={classNames(
          'px-4 py-3 rounded-[var(--site-theme-border-radius,6px)] bg-[var(--site-theme-primary-color,#030712)] text-[var(--site-theme-background-color,#ffffff)] font-medium flex gap-2 items-center justify-center w-full duration-300',
          isLoading || isDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:opacity-80',
        )}
        style={{ fontFamily: 'var(--site-theme-button-font)' }}
      >
        {translations?.['recommendations.modal.subscribe_to_all'] || 'Subscribe to all'}
        {isLoading && (
          <div className="animate-spin w-4 h-4 border-2 border-transparent border-r-[var(--site-theme-primary-color,#030712)] rounded-full" />
        )}
      </button>
      <EmailModal
        isOpen={emailCaptureOpen}
        onClose={() => setEmailCaptureOpen(false)}
        className="w-full inset-x-0 -top-4"
      />
    </div>
  );
};
